import { fetchPost, fetchGet , fetchPut , fetchDelete} from '@/utils/request'

export function recharge (id, params) {
    return fetchPost('/gateway/v1/factors/'+id+'/recharge', params)
}

export function factorBalanceList (params) {
    return fetchGet('/gateway/v1/factor-balance-records', params)
}
export function factorBalanceTotal (params) {
    return fetchGet('/gateway/v1/factor-balance-records-total', params)
}

export function factorExpenseRecord (params) {
    return fetchGet('/gateway/v1/factor-expense-records', params)
}
export function factorRechargeRecord (params) {
    return fetchGet('/gateway/v1/factor-recharge-records', params)
}


